/* QUIETUDE — pied de page partagé.

   Deux comportements, tous deux indispensables :

   1. Les colonnes de liens sont des <details> pour l'accordéon mobile. Au-delà
      de 900px un <details> fermé masque quand même sa liste : aucune règle CSS
      ne le rouvre, il faut poser l'attribut open. Sans ça, deux colonnes sur
      trois sont vides sur ordinateur.

   2. Les sélecteurs pays et langue postent au changement. Le <noscript> du
      snippet garde un bouton de validation pour qui n'a pas JS. */
(function () {
  var mq = window.matchMedia('(min-width:900px)');

  function openColumns() {
    if (!mq.matches) return;
    var cols = document.querySelectorAll('.qtfd-col');
    for (var i = 0; i < cols.length; i++) cols[i].open = true;
  }

  if (mq.addEventListener) {
    mq.addEventListener('change', openColumns);
  } else if (mq.addListener) {
    mq.addListener(openColumns);
  }

  document.addEventListener('DOMContentLoaded', openColumns);
  openColumns();

  document.addEventListener('change', function (e) {
    var el = e.target;
    if (el && el.matches && el.matches('[data-qtfd-submit]') && el.form) el.form.submit();
  });

  /* L'éditeur de thème remonte une section sans recharger la page. */
  document.addEventListener('shopify:section:load', openColumns);
})();
